import assistantsRequests from './assistantsRequests'
import contentRequests from './contentRequests'
import galleryRequests from './galleryRequests'
import recordingRequests from './recordingRequests'
import formsRequests from './formsRequests'
import uploadRequests from './uploadRequests'
import rotatePageRequests from './rotatePageRequests'
import * as calendarRequests from './calendarRequests'
import customVideoRequests from './customVideoRequests'
import usersRequests from './usersRequests'
import sessionsPageRequests from './sessionsPageRequests'
import formStatisticsPageRequests from './formStatisticsPageRequests'
import activitiesRequests from './activitiesRequests'
import geosearchRequests from './geosearchRequests'
import chatMessagesRequests from './chatMessagesRequests'
import assetsRequests from './assetsRequest'
import annotationRequests from './annotationRequests'
import aiCountersRequests from './aiCountersRequests'
import aiObjectsRequests from './aiObjectsRequests'
import aiObjectTenantToModelDependenciesRequests from './aiObjectTenantToModelDependenciesRequests'
import uniqueAIObjectsRequests from './uniqueAIObjectsRequests'
import spatialModelRequests from './spatialModelRequests'
import configRequests from './configRequests'
import tenantSessionsPageRequests from './tenantSessionsPageRequests'
import pointCloudRequests from './pointCloudRequests'
import policiesRequests from './policiesRequests'
import * as accountRequests from './accountRequests'
import notificationsPageRequests from './notificationsPageRequests'
import allFormsRequests from './allFormsRequests'
import trackingRequests from './trackingRequests'
import contentReviewsRequests from './contentReviewsRequests'
import * as inviteRequests from './inviteRequests'
import devicesRequests from './devicesRequests'
import billingSettingsRequests from './billingSettingsRequests'
import * as permissionsRequests from './permissionsRequests'
import * as remindersRequests from './remindersRequests'
import * as reportsRequests from './reportsRequests'
import nlpModelsRequests from './nlpModelsRequests'
import vqaModelsRequests from './vqaModelsRequests'
import tagsRequests from './tagsRequests'
import healthDataRequests from './healthDataRequests'
import bentleyRequests from './bentleyRequests'
import powerBIRequests from './powerBiRequests'
import contentMetadataRequests from './contentMetadataRequests'
import contentSharingRequests from './contentSharingRequests'
import projectsRequests from './projectsRequests'
import iterationsRequests from './iterationsRequests'
import aiExpressionsRequests from './aiExpressionsRequests'
import aiModelsRequests from './aiModelsRequests'
import predictionSetsRequests from './predictionSetsRequests'
import modelTrainingRequests from './modelTrainingRequests'
import advancedFormSettingsRequests from './advancedFormSettingsRequests'
import metricsRequests from './metricsRequests'
import aiReportsRequests from './aiReportsRequests'
import maintenanceRequests from './maintenanceRequests'
import pointCloudGpsMetadataRequests from './pointCloudGpsMetadataRequests'
import sncFiltersRequests from './sncFiltersRequests'
import threeDModelRequests from './threeDModelRequests'
import contractorsRequests from './contractorsRequests'
import workflowsRequests from './workflowsRequests'
import powerBIReportProvidersRequests from './powerBIReportProvidersRequests'
import utilityInfrastructureRequests from './utilityInfrastructureRequests'
import bulkImportsRequests from './bulkImportsRequests'
import selectionListsRequests from './selectionListsRequests'
import selectionListItemsRequests from './selectionListItemsRequests'
import aiReportPublishTemplatesRequests from './aiReportPublishTemplatesRequests'
import annotationAiObjectsRequests from './annotationAiObjectsRequests'

export * from './hooks'

const API = {
  ...assistantsRequests,
  ...contentRequests,
  ...galleryRequests,
  ...recordingRequests,
  ...formsRequests,
  ...uploadRequests,
  ...rotatePageRequests,
  ...calendarRequests,
  ...customVideoRequests,
  ...usersRequests,
  ...sessionsPageRequests,
  ...activitiesRequests,
  ...formStatisticsPageRequests,
  ...geosearchRequests,
  ...chatMessagesRequests,
  ...assetsRequests,
  ...annotationRequests,
  ...aiCountersRequests,
  ...aiObjectsRequests,
  ...aiObjectTenantToModelDependenciesRequests,
  ...uniqueAIObjectsRequests,
  ...spatialModelRequests,
  ...configRequests,
  ...tenantSessionsPageRequests,
  ...trackingRequests,
  ...pointCloudRequests,
  ...policiesRequests,
  ...accountRequests,
  ...allFormsRequests,
  ...notificationsPageRequests,
  ...contentReviewsRequests,
  ...devicesRequests,
  ...billingSettingsRequests,
  ...permissionsRequests,
  ...remindersRequests,
  ...reportsRequests,
  ...nlpModelsRequests,
  ...vqaModelsRequests,
  ...tagsRequests,
  ...healthDataRequests,
  ...inviteRequests,
  ...bentleyRequests,
  ...powerBIRequests,
  ...contentMetadataRequests,
  ...contentSharingRequests,
  ...projectsRequests,
  ...iterationsRequests,
  ...aiExpressionsRequests,
  ...aiModelsRequests,
  ...predictionSetsRequests,
  ...modelTrainingRequests,
  ...advancedFormSettingsRequests,
  ...metricsRequests,
  ...aiReportsRequests,
  ...aiReportPublishTemplatesRequests,
  ...maintenanceRequests,
  ...sncFiltersRequests,
  ...pointCloudGpsMetadataRequests,
  ...threeDModelRequests,
  ...contractorsRequests,
  ...powerBIReportProvidersRequests,
  ...workflowsRequests,
  ...utilityInfrastructureRequests,
  ...bulkImportsRequests,
  ...selectionListsRequests,
  ...selectionListItemsRequests,
  ...annotationAiObjectsRequests,
}

export default API
